export enum ProductType {
  HOTELS = "hotels",
  FLIGHTS = "flights",
  CARS = "cars",
  PACKAGES = "packages",
}

export enum CarOfferCreationTimeUnitType {
  HOUR = "hour",
  HOURS = "hours",
  DAY = "day",
  DAYS = "days",
}
